import { render } from "./InvestorDetails.vue?vue&type=template&id=06a573f3&scoped=true"
import script from "./InvestorDetails.vue?vue&type=script&lang=js"
export * from "./InvestorDetails.vue?vue&type=script&lang=js"

import "./InvestorDetails.vue?vue&type=style&index=0&id=06a573f3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a573f3"]])

export default __exports__